import isEmptyObject from '#shared/util/isEmptyObject.js';

/**
 * Enumerable for MyAccount+GEN migration status ("genAccountMigrationStatus" property)
 * @see https://butr.avast.com/browse/CART-4703
 */
export const GenAccountMigrationStatus = {
	migrated: 'ACC_MIGRATED',
	inProgress: 'ACC_MIGRATION_IN_PROGRESS',
	failed: 'ACC_MIGRATION_FAILED'
};

/**
 * Enumerable for MyAccount+GEN account type ("genAccountType" property)
 * @see https://butr.avast.com/browse/CART-4703
 */
export const GenAccountType = {
	regular: 'REGULAR',
	skeleton: 'SKELETON'
};

/**
 * Account schema
 * @param {object} data
 * @param {object} data.myAccount Raw response from MyAccount
 * @param {object} data.customer Transformed customer object
 * @param {object} data.sessionStore Session store instance
 * @returns {object}
 */
export const accountSchema = ({ myAccount, customer, sessionStore }) => {
	let sessionMyAccountForEmail;
	if (sessionStore) {
		sessionMyAccountForEmail = sessionStore.store.myAccount?.[customer.billing.email];
	}
	const account = Object.assign({}, sessionMyAccountForEmail, myAccount);
	if (isEmptyObject(account)) {
		return null;
	}
	return {
		uuid: account.uuid,
		firstName: account.firstName,
		lastName: account.lastName,
		email: account.email,
		tickets: account.tickets,
		verified: account.verified,
		migrated: account.genAccountMigrationStatus === GenAccountMigrationStatus.migrated,
		status: {
			MyAccount: account.status?.existingMyAccount ? 'existing' : 'new',
			shadow: account.shadow ? 'shadow' : 'account',
			verified: account.verified ? 'verified' : 'unverified'
		},
		genAccountId: account.genAccountId
	};
};
